import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transformResponseHandler } from 'utils/transformResponseHandler';

export const manageSettingsApi = createApi({
    reducerPath: 'manageSettings',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_API_ROUTE}`,
        prepareHeaders: (headers, { getState }) => {
            const token = getState()?.posData?.token;
            if (token) {
                headers.set('Authorization', token);
            }
            return headers;
        },
    }),
    tagTypes: ['Settings'],
    endpoints: (builder) => ({
        getSettings: builder.query({
            query: () => ({
                url: '/pos/settings',
                method: 'GET',
            }),
            providesTags: ['Settings'],
            // transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error),
        }),
        updateSettings: builder.mutation({
            query: (body) => ({
                url: '/pos/settings',
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Settings'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error),
        }),
        generateVendorQr: builder.mutation({
            query: () => ({
                url: '/pos/vendor-table/vendor/generate-qr',
                method: 'POST',
            }),
            invalidatesTags: ['Settings', 'VendorQR'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error),
        }),
        getVendorQr: builder.query({
            query: () => ({
                url: '/pos/vendor-table/vendor/qr-code',
                method: 'GET',
            }),
            providesTags: ['VendorQR'],
            transformResponse: (resp) => transformResponseHandler(resp, false),
            transformErrorResponse: (error) => transformResponseHandler(error),
        }),
        createStripeConnectOnboard: builder.mutation({
            query: (body) => ({
                url: '/pos/settings/stripe-connect/onboard',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Settings'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error),
        }),
        toggleSetting: builder.mutation({
            query: (body) => ({
                url: '/pos/settings/toggle',
                method: 'PATCH',
                body,
            }),
            invalidatesTags: ['Settings'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error),
        }),
        getStripeConnectStatus: builder.query({
            query: () => ({
                url: '/pos/settings/stripe-connect/status',
                method: 'GET',
            }),
            providesTags: ['Settings'],
            transformResponse: (resp) => transformResponseHandler(resp, false),
            transformErrorResponse: (error) => transformResponseHandler(error),
        }),
    }),
});

export const {
    useGetSettingsQuery,
    useUpdateSettingsMutation,
    useToggleSettingMutation,
    useGenerateVendorQrMutation,
    useGetVendorQrQuery,
    useLazyGetVendorQrQuery,
    useCreateStripeConnectOnboardMutation,
    useGetStripeConnectStatusQuery
} = manageSettingsApi;
